import React from 'react';
import { Label, Switch } from 'lib/cortiUI';
export const ToggleSwitch = ({ label, checked, onChange }) => {
    return (React.createElement(Label, { display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" },
        label,
        React.createElement(Switch, { checked: checked, onChange: onChange })));
};
